<template>
<div class="chooseGood">
    <!--选择商品单选-->
    <el-radio-group v-show="$store.state['zsm-good'].chooseGoodModalType==0" v-model="goodId">
        <el-dialog @close="$store.state['zsm-good'].chooseGoodModal=false" top="60px" title="选择课程" :modal="false" :visible.sync="$store.state['zsm-good'].chooseGoodModal">
            <!-- <div slot="title"><span>课程列表</span> <span style="font-size: 12px;color:red;margin-left: 12px">提示：该列表只显示已上架且有章节的课程</span> </div> -->
            <div slot="title"><span>课程列表</span> <span style="font-size: 12px;color:red;margin-left: 12px">提示：该列表只显示已上架且通过审核的课程（注：审核中课程以审核通过内容为准）</span> </div>
            <el-form filterable :inline="true" class="demo-form-inline">
                <el-form-item label="">
                    <el-select clearable v-model="goodForm.goodDict" placeholder="请选择类型">
                        <el-option v-for="item in $store.state['zsm-good'].courseTypeList" :key="item.goodDict" :label="item.title" :value="item.goodDict" />
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-input clearable v-model="goodForm.title" style="width: 220px;" placeholder="请输入内容" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="changeCoursePages(1)">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="courseLoading" height="520px" :data="courseList" @current-change="handleCurrentChange">
                <el-table-column set-current-row width="80" align="center">
                    <template slot-scope="scope">
                        <div class="choose ">
                            <el-radio :disabled="goodId==scope.row.id" :label="scope.row.id"> <span /></el-radio>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="name" label="封面" align="left" width="200">
                    <template slot-scope="scope">
                        <div>
                            <img v-if="scope.row.cover" style="border-radius: 4px; object-fit: cover; object-position:top;vertical-align: top" :src="scope.row.cover" alt="">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="address" align="left" label="标题" width="300">
                    <template slot-scope="scope">
                        <div style="font-size: 14px">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="address" align="left" label="价格">
                    <template slot-scope="scope">
                        <div class="fz14">
                            ￥{{ scope.row.price }}
                        </div>
                    </template>
                </el-table-column>

            </el-table>

            <div v-if="goodForm.total>20" class="flex" style="justify-content: center">
                <el-pagination background layout="prev, pager, next" :total="goodForm.total" page-size="10" @current-change="changeCoursePages" />
            </div>

            <div class="submitCover flex" style="justify-content: flex-end;margin-top: 30px">
                <el-button @click="$store.state['zsm-good'].chooseGoodModal=false">取消</el-button>
                <el-button type="primary" :disabled="goodId==''" @click="chooseGood">确定</el-button>
            </div>
        </el-dialog>
    </el-radio-group>

    <!--选择商品多选-->
    <el-checkbox-group v-show="$store.state['zsm-good'].chooseGoodModalType==1||$store.state['zsm-good'].chooseGoodModalType==2" v-model="giveGoodListIds">
        <el-dialog @close="$store.state['zsm-good'].chooseGoodModal=false;giveGoodListIds=[]" top="60px" title="选择课程" :modal="false" :visible="$store.state['zsm-good'].chooseGoodModal">
            <div slot="title"><span>课程列表</span>
                <span v-if="$store.state['zsm-good'].chooseGoodModalType==1" style="font-size: 12px;color:red;margin-left: 12px">提示：该列表只显示已上架且有章节的课程，最多选择十个课程</span>
                <span v-if="$store.state['zsm-good'].chooseGoodModalType==2" style="font-size: 12px;color:red;margin-left: 12px">提示：该列表只显示已上架的课程</span>
            </div>
            <el-form filterable :inline="true" class="demo-form-inline">
                <el-form-item label="">
                    <el-select clearable v-model="goodForm.goodDict" placeholder="请选择类型">
                        <el-option v-for="item in $store.state['zsm-good'].courseTypeList" :key="item.goodDict" :label="item.title" :value="item.goodDict" />
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-input clearable v-model="goodForm.title" style="width: 220px;" placeholder="请输入内容" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="changeCoursePages(1)">搜索</el-button>
                </el-form-item>

            </el-form>
            <el-table ref="giveCourse" v-loading="courseLoading" height="520px" :data="courseList" @row-click="handleCurrentChangeChild">
                <el-table-column width="80" align="center">
                    <template slot-scope="scope">
                        <div class="choose ">
                            <el-checkbox @change="handleCurrentChangeChild(scope.row)" :disabled="$store.state['zsm-good'].chooseGood.id==scope.row.id" :checked="JSON.stringify(giveGoodListIds).indexOf( scope.row.id)!=-1?true:false" :label="scope.row.id"> <span /></el-checkbox>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="name" label="封面" align="left" width="200">
                    <template slot-scope="scope">
                        <div>
                            <img v-if="scope.row.cover" style="border-radius: 4px; object-fit: cover; object-position:top;vertical-align: top" :src="scope.row.cover" alt="">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="address" align="left" label="标题" width="300">
                    <template slot-scope="scope">
                        <div style="font-size: 14px">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column property="address" align="left" label="价格">
                    <template slot-scope="scope">
                        <div style="font-size: 14px">
                            ￥{{ scope.row.price }}
                        </div>
                    </template>
                </el-table-column>

            </el-table>

            <div v-if="goodForm.total>20" class="flex" style="justify-content: center">
                <el-pagination background layout="prev, pager, next" :total="goodForm.total" page-size="20" @current-change="changeCoursePages" />
            </div>
            <div class="submitCover flex" style="justify-content: flex-end;margin-top: 30px">
                <el-button @click="$store.state['zsm-good'].chooseGoodModal=false;giveGoodListIds=[]">取消</el-button>
                <el-button :disabled="(giveGoodListIds.length>10&&this.$store.state['zsm-good'].chooseGoodModalType==1)||giveGoodListIds==''?true:false" type="primary" @click="chooseGiveCourse">确定</el-button>
            </div>
        </el-dialog>
    </el-checkbox-group>
</div>
</template>

<script>
import {
    getLocalStorage
} from '@/utils/auth'
export default {
    props: ['userInfo'],
    name: 'chooseGood',
    data() {
        return {
            courseLoading: false, // 获取商品详情
            goodForm: {
                shelfFlag: 1, // 已上架
                pageNo: 1,
                pageSize: 20,
                total: 0,
                title: '', //商品标题,
                goodDict: '' //商品类型
            },
            courseList: [], // 课程列表
            goodId: '', //主商品ID
            giveGoodListIds: [], //赠送课程
            giveGoodList: [] //赠送课程
        }
    },

    computed: {
        platformDict() {
            return this.$store.state['zsm-user'].platformDict
        },
        chooseGoodModal() {
            return this.$store.state['zsm-good'].chooseGoodModal
        }
    },
    mounted() {
        this.findGoodList();
    },
    watch: {
        // 弹框展示时获取商品信息
        chooseGoodModal(status) {
            if (status == true) {
                this.findGoodList();
                this.giveGoodListIds = [];
                this.$store.state['zsm-good'].chooseGiveGood.map((item) => {
                    this.giveGoodListIds.push(item.id)
                })
                this.giveGoodList = JSON.parse(JSON.stringify(this.$store.state['zsm-good'].chooseGiveGood));
                this.goodId = this.$store.state['zsm-good'].chooseGood.id || '';
            }
        }
    },
    mounted() {
        this.goodId = this.$store.state['zsm-good'].chooseGood.id || '';
    },
    methods: {
        //多选情况*********************************
        // 确认选择赠品
        chooseGiveCourse() {
            this.$store.state['zsm-good'].chooseGiveGood = JSON.parse(JSON.stringify(this.giveGoodList));
            this.$store.state['zsm-good'].chooseGoodModal = false;
            this.$store.state['zsm-good'].chooseGoodModalType = 0;
        },
        // 选择课程
        handleCurrentChangeChild(row) {
            // 主课程不能再次选择
            if (this.goodId == row.id) {
                return
            }
            if (this.giveGoodListIds.length >= 10 && this.$store.state['zsm-good'].chooseGoodModalType == 1) {
                this.$message.error('最多只能选择十个课程')
                return
            }
            if (JSON.stringify(this.giveGoodList).indexOf(row.id) == -1) {
                this.giveGoodListIds.push(row.id);
                this.giveGoodList.push(row);
            } else {
                this.giveGoodList.map((item, index) => {
                    if (item.id == row.id) {
                        this.giveGoodList.splice(index, 1);
                        this.giveGoodListIds.splice(index, 1);
                    }
                })
            }
        },
        // 单选情况*********************************
        // 主课程选择
        handleCurrentChange(val) {
            if (val) {
                this.goodId = val.id;
            }
        },
        // 选择商品
        chooseGood() {
            this.$store.state['zsm-good'].chooseGoodModal = false;
            this.$store.state['zsm-good'].chooseGood = this.courseList.filter((item) => {
                return item.id == this.goodId
            })[0];
        },
        // 修改分页
        changeCoursePages(val) {
            this.courseListPageNo = val
            this.findGoodList()
        },
        // 获取课程列表
        async findGoodList() {
            this.courseLoading = true;
            let res = await this.$store.dispatch('zsm-good/listDataGood', {
                ...this.goodForm,
                platformDict: this.platformDict,
                loginCode: this.userInfo.mobile
            });
            this.goodForm.total = res.content
            this.courseList = res.list
            this.courseLoading = false
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../style/course-modal.scss";
</style>
